import 'jquery';
import './maskedInput';

$(function() {

  if($('.masked-input').length > 0) {

    $('.masked-input').each(function() {

      let $field = $(this);

      if(!$field.hasClass('hasInputMask')) {
        $field.maskedInput();
      }

    });

  }

});

